/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { cva, cx } from "@panda/css";
import { EdsIcon, IconColor, IconSize } from ".";

export interface CosmosPlayIconProps {
	className?: string;
	color?: IconColor;
	size?: IconSize;
}

const styles = cva({
	base: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		gap: "eds.dimension.8",
		flexShrink: "0",
		borderRadius: "eds.borderRadius.full",
		border: "token(spacing.eds.dimension.1) solid token(colors.eds.border.subdued)",
		background: "eds.fill.secondary.default",
		backdropFilter: "blur(50px)",
		transition: "background token(animations.eds.duration.200) token(animations.eds.easing.easeInOutQuad)",
		"&:hover": {
			cursor: "pointer",
			background: "eds.fill.secondary.hover",
		},
	},
	variants: {
		size: {
			xs: { width: "eds.dimension.24", height: "eds.dimension.24" },
			sm: { width: "eds.dimension.32", height: "eds.dimension.32" },
			md: { width: "eds.dimension.48", height: "eds.dimension.48" },
			lg: { width: "eds.dimension.64", height: "eds.dimension.64" },
			xl: { width: "eds.dimension.80", height: "eds.dimension.80" },
			xxl: { width: "eds.dimension.80", height: "eds.dimension.80" },
		},
	},
});

export const CosmosPlayIcon = ({ className, color, size }: CosmosPlayIconProps): React.JSX.Element | null => {
	return (
		<div className={cx("cosmos-play-icon", styles({ size: size || "md" }), className)}>
			<EdsIcon color={color} size={size} icon="PlayFilled" />
		</div>
	);
};
